import React from 'react';
import {TypeImplementation} from '@packages/systems/wfdl';
import {
  ContextualExpressions,
  stripAnn,
} from '@packages/utilities/contextual-expression';
import {useRiveContext} from './RiveContext';
import {getString} from '@packages/utilities/json';
import {VStack} from '@packages/systems/spring';
import {
  AlignmentType,
  RiveAlignmentSelect,
} from '@packages/systems/ui/shared-ui/Rive/RiveLayoutSelect';
import {Label} from '@packages/systems/ui/shared-ui/Rive';

const id = 'rive-alignment-input';
const label = 'Align';

export const alignment = TypeImplementation.Custom({
  render: function AlignmentInput({expr}) {
    const {selectAlignment, hasInstance} = useRiveContext();
    const literal = ContextualExpressions.getLiteral(stripAnn(expr));
    const state = literal
      ? (getString(literal.value) as AlignmentType)
      : undefined;

    return (
      <VStack spacing={1}>
        <Label id={`rive-settings-rive-${label}-select-label`} htmlFor={id}>
          {label}
        </Label>
        <RiveAlignmentSelect
          aria-label={label}
          data-automation-id={id}
          aria-labelledby={`rive-settings-${label}-select-label`}
          value={state}
          isDisabled={!hasInstance}
          onChange={selectAlignment}
        />
      </VStack>
    );
  },
  system: {
    labelVariant: 'hidden',
  },
});
